export const LabelUltraTrial = () => {
  return (
    <label
      className="nj-label-free nj-label-ultra"
      data-e2e="label-tier-ultra-trial"
    >
      Ultra Trial
    </label>
  );
};
